import { Box, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import IconMapping from "../../../../../icons/IconMapping";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { AssetTypes } from "../../../../../utils/constants";

const AssetTypeSelect = ({ formData, setFormData, disabled = false }) => {
  const colors = useColors();
  return (
    <>
      <InputLabel id="asset-type-select-label">
        <Box display={"flex"} flexDirection={"row"} gap={1}>
          <Typography variant="body2" color={colors.text_secondary}>
            Asset Category
          </Typography>
          <span style={{ color: colors.error_main }}>*</span>
        </Box>
      </InputLabel>
      <Select
        variant="outlined"
        labelId="asset-type-select-label"
        label="Asset Category"
        value={formData.stepAssetDetails.asset.assetType || ""}
        displayEmpty
        onChange={(event) =>
          setFormData((prevData) => ({
            ...prevData,
            stepAssetDetails: {
              asset: {
                ...prevData.stepAssetDetails.asset,
                assetType: event.target.value,
              },
            },
          }))
        }
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "8px",
            borderColor: colors.divider2,
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "0.5px solid " + colors.divider2,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "0.5px solid " + colors.grey_500,
            },
          },

          // Add styles for when an option is selected
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.grey_500,
            borderWidth: "1px",
          },

          // Add styles for when dropdown is open
          "&.MuiOutlinedInput-root.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.grey_500,
              borderWidth: "1px",
            },
          },

          "& .MuiInputBase-input::placeholder": {
            color: colors.text_primary,
          },
          width: "100%",
          "& .MuiInputBase-root": { height: "32px" },
        }}
      >
        {AssetTypes.map((type) => {
          const IconType = IconMapping[type];
          return (
            <MenuItem key={type} value={type}>
              <Box display="flex" alignItems="center" gap={1}>
                <SvgToIcon IconLogo={IconType} style={{ width: "20px" }} />
                <></>
                <Typography variant="body2">{type}</Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};

export default AssetTypeSelect;
